export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_08_TSeries.754e9097.mp4";